module.exports = __webpack_public_path__ + "static/media/Aveny soffa 3-sits med divan brooksville soffbord calypso fårskinn sahara miljö 2023 1.8a19bf3e.jpg";